import useSwr from 'swr';
import Axios from '@/utils/Axios';
import useConfigStore, { ApiPlatformValue } from '@/stores/useConfigStore';

interface RequestQuery {
  platform?: ApiPlatformValue;
}

export interface Profile {
  /**
   * 地区代码
   */
  areaCode?: string;
  /**
   * 头像
   */
  avatar?: string;
  /**
   * 是否启用
   */
  enabled: number;
  /**
   * 性别 1男 2女
   */
  gender?: number;
  /**
   * 用户id
   */
  id: number;
  /**
   * 身份 'staff' | 'student' | 'teacher' | 'parent'
   */
  identity: Identity;
  /**
   * 姓名
   */
  name: string;
  /**
   * 手机号
   */
  phone?: string;
  /**
   * 偏好是否已设置
   */
  prefer: boolean;
  /**
   * 系统角色
   */
  sysRole: string;
}

export enum Identity {
  Parent = 'parent',
  Staff = 'staff',
  Student = 'student',
  Teacher = 'teacher',
}

export async function getProfile() {
  const response = await Axios.get<Profile>(`/users/profile`, {
    params: {
      platform: useConfigStore.getState().apiPlatformValue,
    } satisfies RequestQuery,
  });
  return response.data;
}

export default function useProfile() {
  const apiPlatformValue = useConfigStore((x) => x.apiPlatformValue);

  const { data, mutate } = useSwr(
    ['/users/profile', { platform: apiPlatformValue }],
    () => getProfile(),
  );

  return {
    data,
    mutate,
  } as const;
}
